/**
 * Privacy Policy Page
 *
 * Displays the Privacy Policy legal document for admeru.
 * Loads the markdown file and renders it with proper formatting.
 */

import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/privacy-policy.md"
      title="Privacy Policy"
      description="Learn how admeru collects, uses, and protects your personal information. We are committed to transparency and data protection."
    />
  );
};
